import { type Auth, signOut as endSession } from "firebase/auth";
import { dropAllShells } from "./shell";
import { clearMemory, dropScope, note } from "./store/store";

const DROP_WAIT_MS = 2_000;

/** Each sign-out of the app: delete the client cache of the user on the disk, then end the session (SO-4341). */
export async function signOut(auth: Auth): Promise<void> {
  const started = performance.now();
  const dropped = dropScope("sign_out", true).then(() => true, () => false);
  const done = await Promise.race([dropped, new Promise<false>((resolve) => setTimeout(() => resolve(false), DROP_WAIT_MS))]);
  clearMemory();
  dropAllShells();
  const ms = Math.round(performance.now() - started);
  note("cache_sign_out", `sign-out: cache ${done ? "deleted" : "not deleted"} in ${ms} ms`, { deleted: done, ms });
  return endSession(auth);
}
